export const globalMessages = {
    routingNumerRequired: 'The Routing Number is required',
    routingNumerInvalid: 'The Routing Number provided is invalid',
    routingValidationFailed: 'The Routing Number Validation failed. Please try again after sometime.',
    accountNumberRequired: 'The Account Number is required',
    accountNumberInvalid: ' The Account Number provided is invalid',
    accountHolderRequired: 'The Account Holder Name is required',
    accountHolderInvalid: 'The Account Holder Name is invalid',
    accountHolderPatternInvalid: 'The Account Holder Name should contain only alphabets',
    fieldRequiredMsg: 'Please fill all mandatory fields before clicking on ‘Continue’ button',
    selectRequiredMsg: 'fields are mandatory',
    zipInvalid: 'Zip Code is not valid',
    recaptchreqired: 'Please Check the Box',
    invalidInput: 'The information provided is incorrect, please try again.',

    labelRountingNumber: 'Routing Number',
    labelAccountNumber: 'Account Number',
    labelAccountHolderName: 'Account Holder Name',

    paymentportalRoute: '/paymentportal',
    policydetailRoute: '/paymentpolicydetail',
    receiptRoute: '/receipt',
    noDueRoute: '/noDue',
    fetchInboundCommsServiveURL: '/fetch-inbound-comms',
    psicCarrier: 'PSIC',
    application360: '360',
    policyCategory: 'policy',
    billingCategory: 'billing',
    getDocumentsCategory: 'getDocuments',
    consumerRole: 'consumer',
    getClaims: 'getClaims',

    serviceMsgError: 'Failed to load data. <b>Click the icon to retry.</b>',
    noDataAvailabelMsg: 'No records available.',

    currencyFields: ['Monthly premium', 'Annual premium'],
    dateFields: ['Effective date', 'Expiration date'],
    lobFields: ['Line of business'],
    policySnapshotFields: [
        'Policy number',
        'Status',
        'Effective date',
        'Expiration date',
        'Insurance Score Tier',
        'Address',
        'Monthly premium',
        'Annual premium',
        'Line of business',
        'Occupancy',
        'Term',
    ],
    compactBreakpoint: 500,
    themeList: ['red', 'green', 'psic', 'blue', 'neutral'],
};

export const SECTION_SELECTOR_MAP: Record<string, string> = {
    'Insured profile': 'app-insured-profile',
    'Latest activities': 'app-latest-activities',
    'Transactions information': 'app-transactions-information',
    'Inbound / Outbound comms': 'app-inbound-outbound-comms',
    'Recent documents': 'app-recent-documents',
    Inspections: 'app-inspections',
    Notes: 'app-notes',
    'Moratorium activity': 'app-moratorium',
    'Policy Snapshot': 'app-policy-general-information',
    'Policy general information': 'app-policy-general-information',
    'Payment information': 'app-payment-information',
    'Billing information': 'app-billing-information',
    'Contact preferences': 'app-contact-preferences',
    Coverages: 'app-coverages',
    Valuables: 'app-valuables',
    'Discounts & Surcharges': 'app-discounts',
    Fees: 'app-fees',
    Claims: 'app-claims',
};
